import { Component, OnInit, Input } from '@angular/core';
import { HolidayService } from '../../services/holidayservices/holiday.service';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from '../../services/dashboardservices/dashboard.service';
import { SharedModeService } from '../../services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../loader/loader.component';


import { HolidayFormComponent } from './holiday-form/holiday-form.component';


@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, HolidayFormComponent]
})
export class HolidayComponent implements OnInit {
  typeArr: any = [];
  public showSpinner = true;
  public holidays: any[] = [];
  public backgroundColor: any;
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  public showHolidayModal = false;

  constructor(public Holiday: HolidayService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private router: Router) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.fetchHolidays();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }

  fetchHolidays(): void {
    this.showSpinner = true;
    this.Holiday.getHolidays().then((data) => {
      this.showSpinner = false;
      if (data.success == true) {
        this.holidays = this.processHolidays(data.data);
      }
    });
  }

  processHolidays(data: any[]): any[] {
    if (!data || data.length === 0) return [];

    // Sort by date ascending for grouping
    const sorted = [...data].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    const grouped: any[] = [];
    let currentGroup: any = null;

    sorted.forEach((item) => {
      const itemDate = new Date(item.date);

      if (currentGroup && currentGroup.day_name === item.day_name && this.isConsecutive(currentGroup.endDate, item.date)) {
        currentGroup.endDate = item.date;
        currentGroup.isRange = true;
      } else {
        if (currentGroup) grouped.push(currentGroup);
        currentGroup = {
          ...item,
          startDate: item.date,
          endDate: item.date,
          isRange: false
        };
      }
    });

    if (currentGroup) grouped.push(currentGroup);

    // Finally sort descending for display (latest first)
    return grouped.sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
  }

  isConsecutive(dateString1: string, dateString2: string): boolean {
    const d1 = new Date(dateString1);
    const d2 = new Date(dateString2);
    const diffTime = Math.abs(d2.getTime() - d1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 1;
  }

  openModal() {
    this.showHolidayModal = true;
  }

  closeModal() {
    this.showHolidayModal = false;
  }

  handleHolidaySaved() {
    this.closeModal();
    this.fetchHolidays();
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  public colorPalette: string[] = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
    '#F06292', '#AED581', '#FFD54F', '#4DB6AC', '#7986CB',
    '#9575CD', '#FF8A65', '#4FC3F7', '#D4E157', '#81C784'
  ];

  getItemColor(index: number): string {
    return this.colorPalette[index % this.colorPalette.length];
  }

  getBackground(date: any) {
    const currentdate = new Date();
    const objDate = new Date(date)
    if (objDate > currentdate) {
      // Future Day
      return "#FFFFFF"
    } else {
      return "#EDFFED"
    }
  }
  getDay(date: any) {
    const date_array = date;
    const date_slice = date_array.slice(8, 10);
    return date_slice
  }

  getYear(date: string) {
    const year_array = date;
    const year_slice = year_array.slice(0, 4);
    return year_slice
  }

  getMonth(date: any) {
    const monthName = function (month: any) {
      const monthList = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return monthList[month.getMonth()];
    };
    const month_name = monthName(new Date(date));
    return month_name;
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.user = this.userInfo
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  isavailablefeature(type: string): boolean {
    switch (type) {
      case "isView":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.holdays_data.data.values.view === false
      case "isAdd":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.holdays_data.data.values.add === false
      case "isupdate":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.holdays_data.data.values.update === false
      case "isDelete":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.holdays_data.data.values.delete === false
      default:
        return false;


    }
    return false
  }
}
